import React from 'react';
import { extractDcfVerdict } from '../utils/interpretTestData';

/**
 * DcfVerdict — the headline DCF fair-value read ("DCF fair value $X · N% above /
 * upside to fair value · model estimate"), shown near the top of the authed
 * Screener + Portfolio detail panels. Mirrors the public grade card's verdict so
 * signed-in users see the same concrete valuation call, not just the raw test.
 * Self-contained inline styles so it drops in anywhere without CSS wiring.
 * Renders nothing when the DCF numbers aren't available (e.g., ETFs/crypto).
 */
const wrap = {
  display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: '0.45rem',
  margin: '0 0 0.9rem', padding: '0.55rem 0.75rem',
  background: '#0C1220', border: '1px solid #1E293B', borderRadius: 8,
};
const label = {
  fontSize: '0.62rem', fontWeight: 700, textTransform: 'uppercase',
  letterSpacing: '0.05em', color: '#64748B',
};
const val = {
  fontFamily: "var(--font-mono, 'JetBrains Mono', monospace)",
  fontWeight: 700, fontSize: '1rem', color: '#F1F5F9',
};
const verdictStyle = { fontSize: '0.8rem', fontWeight: 600 };
const note = { marginLeft: 'auto', fontSize: '0.6rem', color: '#64748B', fontStyle: 'italic' };

// price: the live price shown on the row, so the % matches what the user sees.
export default function DcfVerdict({ convexTests, price }) {
  const d = extractDcfVerdict(convexTests, price);
  if (!d) return null;
  return (
    <div style={wrap}>
      <span style={label}>DCF fair value</span>
      <span style={val}>
        ${d.fairValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </span>
      <span style={{ ...verdictStyle, color: d.color }}>{d.verdict}</span>
      <span style={note}>model estimate</span>
    </div>
  );
}
